import { Component, OnInit } from "@angular/core";
import { SharedDataService } from "../../sharedData.service";
import { Subject } from "rxjs";
import { AlertComponent } from "ngx-bootstrap/alert";
import * as _ from "lodash";
import { NbcLoggerService } from "../../logger/nbc-logger.service";

@Component({
    selector: "nbc-modal-alert",
    templateUrl: "./nbc-modal-alert.component.html",
    standalone: false
})
export class NbcModalAlerts implements OnInit {
    constructor(
        private _sharedData: SharedDataService,
        private log: NbcLoggerService
    ) {}

    alerts: any[] = [];
    dismissible = true;

    onClosed(dismissedAlert: AlertComponent): void {
        this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
    }

    unsetAlerts() {
        this._sharedData.removeModalAlert();
    }

    ngOnInit() {
        this._sharedData.getModalAlertMessage().subscribe((msg) => {
            if (_.isUndefined(this.alerts)) {
                this.alerts = [];
            }
            if (msg.type) {
                const newMsg = {
                    type: msg.type,
                    msg: msg.msg,
                    displaytype: "",
                };
                switch (newMsg.type) {
                    case "danger":
                        newMsg.displaytype = "Error";
                        break;
                    case "success":
                        newMsg.displaytype = "Success";
                        break;
                    case "info":
                        newMsg.displaytype = "Heads up";
                        break;
                }

                this.alerts.push(newMsg);
                setTimeout(() => this.unsetAlerts(), 2000);
            }
        });
    }
}
